interface RocketAndHandWithCoinSVGProps {
  color: string;
  style: React.CSSProperties;
}

const RocketAndHandWithCoinSVG = ({
  color,
  style,
}: RocketAndHandWithCoinSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <g clipPath="url(#clip0_768_10632)">
      <path
        d="M23.0723 14.3623C23.0723 14.3623 23.6747 8.78759 25.9313 6.40664C27.3083 4.95321 30.741 4.73328 32.8351 4.25518C35.436 3.66233 37.1189 3.25116 40.8959 3.25116H44.6251"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.1543 9.90634H44.6253"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M49.3008 0.535522H45.5047C45.017 0.535522 44.625 0.927567 44.625 1.41523V11.5701C44.625 12.0578 45.017 12.4498 45.5047 12.4498H49.3008"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.249 22.3657C24.249 23.3889 25.0809 24.2303 26.1136 24.2303C27.1463 24.2303 27.9782 23.3984 27.9782 22.3657C27.9782 21.333 27.2133 20.8645 26.1136 20.5011C25.1383 20.1856 24.249 19.6692 24.249 18.6365C24.249 18.0532 24.5168 17.5273 24.9471 17.1831"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.1035 24.2303V25.2821"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.6435 13.8364C27.1463 13.7216 26.6395 13.6642 26.104 13.6642C22.3175 13.6642 19.248 16.7337 19.248 20.5202C19.248 24.3068 22.3175 27.3762 26.104 27.3762C29.8906 27.3762 32.96 24.3068 32.96 20.5202C32.96 19.8413 32.8644 19.1911 32.6827 18.5696"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.1559 9.90628C40.2571 9.90628 39.4252 10.4418 39.0905 11.2832C38.6029 12.488 37.4554 14.2188 34.7685 15.2993C33.927 15.634 33.1047 16.0164 32.3397 16.5137C31.5843 16.9918 30.5994 17.7663 29.7102 18.3496C28.7157 19.0094 28.0942 19.0859 27.4535 18.3496C27.444 18.3305 27.4344 18.3209 27.4153 18.3018C26.8989 17.6802 27.0137 16.7623 27.6543 16.2746C28.6966 15.481 30.1691 14.4004 31.5748 12.4976C32.0337 11.8761 31.5939 10.9677 30.7907 10.9677C30.7907 10.9677 29.3086 10.8434 28.1515 12.2012"
        stroke={color}
        strokeWidth="1.07095"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.3361 28.4567C22.2405 30.3691 21.9919 32.358 21.5329 34.4139C21.1504 36.135 20.6245 37.904 19.9456 39.7304L18.9033 42.446"
        stroke={color}
        strokeWidth="1.07095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46329 42.446L5.42103 39.7304C-2.87884 17.7376 12.6786 2.40967 12.6786 2.40967C12.6786 2.40967 17.0102 6.68391 19.8884 13.9511"
        stroke={color}
        strokeWidth="1.07095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.6709 33.7063C-2.99386 40.371 3.02068 49.4645 3.02068 49.4645L3.75696 48.7283C6.11878 46.3664 9.33164 45.0373 12.6784 45.0373C16.0251 45.0373 19.2284 46.3664 21.5998 48.7283L22.336 49.4645C22.336 49.4645 28.3506 40.3806 21.6858 33.7063"
        stroke={color}
        strokeWidth="1.07095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0961 25.9801C17.0961 28.4184 15.1167 30.3978 12.6784 30.3978C10.2401 30.3978 8.26074 28.4184 8.26074 25.9801C8.26074 23.5418 10.2401 21.5624 12.6784 21.5624C15.1167 21.5624 17.0961 23.5418 17.0961 25.9801Z"
        stroke={color}
        strokeWidth="1.07095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2529 10.5278C16.7038 11.7422 14.7723 12.4594 12.6782 12.4594C10.5841 12.4594 8.65257 11.7422 7.10352 10.5278"
        stroke={color}
        strokeWidth="1.07095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_768_10632">
        <rect width="49.8374" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default RocketAndHandWithCoinSVG;
